export default {
  data() {
    return {}
  },
  methods: {
    compareCommercialName(a, b) {
      var nameA = this.$translateMaterial(a).toUpperCase() // ignore upper and lowercase
      var nameB = this.$translateMaterial(b).toUpperCase() // ignore upper and lowercase
      if (nameA < nameB) {
        return -1 //nameA comes first
      }
      if (nameA > nameB) {
        return 1 // nameB comes first
      }
      return 0 // names must be equal
    },
    compareField(a, b) {
      var nameA = a[this.sortField].toUpperCase() // ignore upper and lowercase
      var nameB = b[this.sortField].toUpperCase() // ignore upper and lowercase
      if (nameA < nameB) {
        return -1 //nameA comes first
      }
      if (nameA > nameB) {
        return 1 // nameB comes first
      }
      return 0 // names must be equal
    },

    getMaterialsArray(materialstext) {
      let promises = []
      for (let materialtext in materialstext) {
        if (!(materialstext[materialtext] in this.$updateavailableMaterials)) {
          this.$updateavailableMaterials[materialstext[materialtext]] = []
        }
        if (this.$updateavailableMaterials[materialstext[materialtext]].length == 0) {
          promises.push(
            new Promise((resolve, reject) => {
              var resolveOnce = snapshot => {
                snapshot.forEach(doc => {
                  let newmat = doc.data()
                  newmat.id = doc.id
                  this.$updateavailableMaterials[materialstext[materialtext]].push(newmat)
                })
                resolve(this.$updateavailableMaterials[materialstext[materialtext]])
              }
              this.$db.collection(materialstext[materialtext]).onSnapshot(snapshot => {
                this.$updateavailableMaterials[materialstext[materialtext]].splice(
                  0,
                  this.$updateavailableMaterials[materialstext[materialtext]].length
                )
                resolveOnce(snapshot)
              }, reject)
            })
          )
        } else {
          promises.push(
            new Promise(resolve => {
              resolve(this.$updateavailableMaterials[materialstext[materialtext]])
            })
          )
        }
      }
      return Promise.all(promises)
    },

    getMaterialsIdArray(materialstext) {
      let promises = []
      for (let materialtext in materialstext) {
        if (!(materialstext[materialtext] in this.$updateavailableMaterials)) {
          this.$updateavailableMaterials[materialstext[materialtext]] = []
        }
        if (this.$updateavailableMaterials[materialstext[materialtext]].length === 0) {
          promises.push(
            new Promise((resolve, reject) => {
              let resolveOnce = snapshot => {
                snapshot.forEach(doc => {
                  let newmat = doc.id
                  this.$updateavailableMaterials[materialstext[materialtext]].push(newmat)
                })
                resolve(this.$updateavailableMaterials[materialstext[materialtext]])
              }
              this.$db.collection(materialstext[materialtext]).onSnapshot(snapshot => {
                this.$updateavailableMaterials[materialstext[materialtext]].splice(
                  0,
                  this.$updateavailableMaterials[materialstext[materialtext]].length
                )
                resolveOnce(snapshot)
              }, reject)
            })
          )
        } else {
          promises.push(
            new Promise(resolve => {
              resolve(this.$updateavailableMaterials[materialstext[materialtext]])
            })
          )
        }
      }
      return Promise.all(promises)
    },

    getMaterialArray(materialtext) {
      if (!(materialtext in this.$updateavailableMaterials)) {
        this.$updateavailableMaterials[materialtext] = []
      }
      if (this.$updateavailableMaterials[materialtext].length === 0) {
        return new Promise((resolve, reject) => {
          var resolveOnce = snapshot => {
            snapshot.forEach(doc => {
              let newmat = doc.data()
              newmat.id = doc.id
              this.$updateavailableMaterials[materialtext].push(newmat)
            })
            resolve(this.$updateavailableMaterials[materialtext])
          }
          this.$db.collection(materialtext).onSnapshot(snapshot => {
            this.$updateavailableMaterials[materialtext].splice(0, this.$updateavailableMaterials[materialtext].length)
            resolveOnce(snapshot)
          }, reject)
        })
      }
      return new Promise(resolve => {
        resolve(this.$updateavailableMaterials[materialtext])
      })
    },
    async getMaterialArrayFiltered(newarray, materialtext, catalog) {
      const hasVariants = !this.$moduleConfiguration[catalog.type].materials.noVariants.includes(materialtext)
      await this.getMaterialArray(materialtext).then(arrayresponse => {
        const cloneDeep = require('clone-deep')
        for (let index in arrayresponse) {
          if (catalog.material[materialtext] && catalog.material[materialtext][arrayresponse[index].id]) {
            let newmat = cloneDeep(arrayresponse[index])
            newmat.variants = []
            if (hasVariants) {
              for (let variant in arrayresponse[index].variants) {
                if (catalog.material[materialtext][newmat.id][arrayresponse[index].variants[variant].id]) {
                  newmat.variants.push(arrayresponse[index].variants[variant])
                }
              }
            } else {
              for (let variant in arrayresponse[index].variants) {
                if (catalog.material[materialtext][newmat.id]) {
                  newmat.variants.push(arrayresponse[index].variants[variant])
                }
              }
            }
            newarray.push(newmat)
            newarray.sort((a, b) => this.compareCommercialName(a, b))
          }
        }
      })
    },
    async getMaterialArrayCatalogFiltered(newarray, materialtext, catalog) {
      await this.getMaterialArray(materialtext).then(arrayresponse => {
        const cloneDeep = require('clone-deep')
        for (let index in arrayresponse) {
          if (catalog.material[materialtext][arrayresponse[index].id]) {
            let newmat = cloneDeep(arrayresponse[index])
            newmat.variants = []
            for (let variant in arrayresponse[index].variants) {
              if (catalog.material[materialtext][newmat.id][arrayresponse[index].variants[variant].id]) {
                newmat.variants.push(arrayresponse[index].variants[variant])
              }
            }
            newarray.push(newmat)
          }
        }
        return
      })
    },
    async getModelListByMaterial(materialId, materialKey, moduleConfiguration) {
      const modelList = []
      const collectionRef = this.$db.collection(moduleConfiguration.models)
      // TODO: implement a solution for collections which are arrays
      switch (materialKey) {
        case moduleConfiguration.materials.Pel: {
          for (let i = moduleConfiguration.minPel; i <= moduleConfiguration.maxPel; i++) {
            const snapShot = await collectionRef.where(`pell${i}mat`, '==', materialId).get()
            this.pushDocsInArray(snapShot, modelList)
          }
          if (moduleConfiguration.materials.Rip) {
            for (let i = moduleConfiguration.minRip; i <= moduleConfiguration.maxRip; i++) {
              const snapShot = await collectionRef.where(`rip${i}mat`, '==', materialId).get()
              this.pushDocsInArray(snapShot, modelList)
            }
          }
          break
        }
        case moduleConfiguration.materials.Pun: {
          const query =
            moduleConfiguration.materials.Pun === 'Pun'
              ? collectionRef.where('battmat', '==', materialId)
              : collectionRef.where('treads', 'array-contains', materialId)
          const snapShot = await query.get()
          this.pushDocsInArray(snapShot, modelList)
          break
        }
        case moduleConfiguration.materials.Mor: {
          let snapShot = await collectionRef.where('intemat', '==', materialId).get()
          this.pushDocsInArray(snapShot, modelList)
          snapShot = await collectionRef.where('tacczepp', '==', materialId).get()
          this.pushDocsInArray(snapShot, modelList)
          break
        }
        case moduleConfiguration.materials.Mat: {
          const snapShot = await collectionRef.where('guardmat', '==', materialId).get()
          this.pushDocsInArray(snapShot, modelList)
          break
        }
        case moduleConfiguration.materials.Sug: {
          const snapShot = await collectionRef.where('fascmat', '==', materialId).get()
          this.pushDocsInArray(snapShot, modelList)
          break
        }
        case moduleConfiguration.materials.PaS: {
          const snapShot = await collectionRef.where('contrmat', '==', materialId).get()
          this.pushDocsInArray(snapShot, modelList)
          break
        }
        case moduleConfiguration.materials.Pat: {
          const snapShot = await collectionRef.where('sottmat', '==', materialId).get()
          this.pushDocsInArray(snapShot, modelList)
          break
        }
        case moduleConfiguration.materials.Mez: {
          const snapShot = await collectionRef.where('punmat', '==', materialId).get()
          this.pushDocsInArray(snapShot, modelList)
          break
        }
        case moduleConfiguration.materials.Acc: {
          let snapShot = await collectionRef.where('fodposmat', '==', materialId).get()
          this.pushDocsInArray(snapShot, modelList)
          snapShot = await collectionRef.where('fodantmat', '==', materialId).get()
          this.pushDocsInArray(snapShot, modelList)
          break
        }
      }
      return modelList
    },
    pushDocsInArray(snapshot, array) {
      snapshot.forEach(doc => {
        const d = doc.data()
        d.id = doc.id
        array.push(d)
      })
    },
  },
}
